import React, { PropTypes } from "react";
import { Field } from "redux-form";
import { FormattedMessage } from "react-intl";
import classNames from "classnames";
import _ from "lodash";

import { TextInput } from "../../../../../common/form";

import clientCoverageTypes from "../enums/clientCoverageTypes";

import { MAX_DECIMAL } from "../../../../../common/Configurations/DecimalConfiguration";

class RenderCoverages extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      prices: [],
    };
  }

  componentWillMount() {
    const initPrices = this.props.initValues.prices;
    const prices = [];

    this.props.fields.removeAll();

    this.props.classList.map((_class) => {
      clientCoverageTypes.map((_type) => {
        let price = _.find(initPrices, {
          classId: _class.classId,
          coverageType: _type.value,
        });
        if (!price) {
          const clientRate = this.props.initValues[_type.idClient];
          const providerRate = this.props.initValues[_type.idProvider];
          const tpaFee = this.props.initValues[_type.tpaFee];

          price = {
            clientRate,
            providerRate,
            tpaFee,
            classId: _class.classId,
            coverageType: _type.value,
            classes: {
              name: _class.name,
            },
          };
        }
        prices.push(price);

        this.props.fields.push({ ...price, className: _class.name });
      });
    });
    this.setState({ prices });
  }

  getFields() {
    return this.props.fields.getAll();
  }

  render() {
    const fields = this.props.fields.map((rate, index) => {
      const coverageType = _.get(this.state, `prices[${index}].coverageType`);
      const rowClasses = classNames({
        row: true,
        "list-type": true,
        "first-of-group": coverageType === "SINGLE",
      });
      return (
        <div className={rowClasses} key={index}>
          <div className="cell">
            <p>
              {_.get(
                this.state,
                `prices[${index}].classes.name`,
                <FormattedMessage id="common.loading" />
              )}
            </p>
          </div>
          <div className="cell">
            <p>
              {
                <FormattedMessage
                  id={
                    clientCoverageTypes.find(
                      (type) => type.value === coverageType
                    ).key
                  }
                />
              }
            </p>
          </div>
          <div className="cell dollar">
            <Field
              id={`${rate}.invoicedClientRate`}
              name={`${rate}.invoicedClientRate`}
              component={TextInput}
              type="absNumber"
              readOnly={this.props.readOnly}
              fixed={MAX_DECIMAL}
            />
          </div>
          <div className="cell dollar">
            <Field
              id={`${rate}.clientRate`}
              name={`${rate}.clientRate`}
              component={TextInput}
              type="absNumber"
              onBlur={this.props.onChangeClientRate.bind(
                null,
                `${rate}.clientRate`
              )}
              readOnly={this.props.readOnly}
              fixed={MAX_DECIMAL}
            />
          </div>
          <div className="cell dollar">
            <Field
              id={`${rate}.providerRate`}
              name={`${rate}.providerRate`}
              component={TextInput}
              type="absNumber"
              readOnly="readonly"
              fixed={MAX_DECIMAL}
            />
          </div>
          <div className="cell dollar">
            <Field
              id={`${rate}.tpaFee`}
              name={`${rate}.tpaFee`}
              component={TextInput}
              type="absNumber"
              readOnly={this.props.readOnly}
              fixed={MAX_DECIMAL}
            />
          </div>
          <div className="cell dollar">
            <Field
              id={`${rate}.gapFee`}
              name={`${rate}.gapFee`}
              component={TextInput}
              type="number"
              readOnly={this.props.readOnly}
              fixed={MAX_DECIMAL}
            />
          </div>
        </div>
      );
    });

    return <div>{fields}</div>;
  }
}

RenderCoverages.propTypes = {
  classList: PropTypes.array,
  initValues: PropTypes.object,
  fields: PropTypes.object,
  meta: PropTypes.object,
  onChangeClientRate: PropTypes.func,
  readOnly: PropTypes.bool,
};

export default RenderCoverages;



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/client-coverages/priceCalculation/RenderCoverages.js